module.exports = __webpack_public_path__ + "img/Middle-Horizontal-Rectangular-Attachment-46.42558f0c.png";